import { API } from './api'
import {
  makeDeleteRequest,
  makeGetRequest,
  makePostRequest,
  makePutRequest,
} from './fetchCalls'

async function listPermissions() {
  return makeGetRequest(API.PERMISSIONS.LIST_PERMISSIONS)
}

async function listMembershipGroups() {
  return makeGetRequest(API.PERMISSIONS.MEMBERSHIP_GROUPS)
}

async function createMembershipGroup(data) {
  return makePostRequest(API.PERMISSIONS.MEMBERSHIP_GROUPS, {
    body: JSON.stringify(data),
  })
}

async function updateMembershipGroup(id, data) {
  return makePutRequest(`${API.PERMISSIONS.MEMBERSHIP_GROUPS}/${id}`, {
    body: JSON.stringify(data),
  })
}

async function deleteMembershipGroup(id) {
  return makeDeleteRequest(`${API.PERMISSIONS.MEMBERSHIP_GROUPS}/${id}`)
}

const PermissionsApi = {
  listPermissions,
  listMembershipGroups,
  createMembershipGroup,
  updateMembershipGroup,
  deleteMembershipGroup,
}

export default PermissionsApi
